import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { pageHead, publicRow } from "@/lib/route-head";
const JournalArticlePage = lazy(() => import("@/pages/JournalArticle"));

type ArticleMeta = { title: string; seo_title: string | null; seo_description: string | null; summary: string | null; cover_image_url: string | null };

export const Route = createFileRoute("/_public/journal/$slug")({
  loader: ({ params }) =>
    publicRow<ArticleMeta>(
      `journal_articles?select=title,seo_title,seo_description,summary,cover_image_url&slug=eq.${encodeURIComponent(params.slug)}&is_published=eq.true&deleted_at=is.null`,
    ),
  head: ({ params, loaderData }) =>
    pageHead({
      path: `/journal/${params.slug}`,
      title: loaderData?.seo_title || (loaderData?.title ? `${loaderData.title} | Amorette Journal` : "Amorette Journal"),
      description: loaderData?.seo_description || loaderData?.summary || "Stories from Amorette curated dining experiences.",
      image: loaderData?.cover_image_url,
      type: "article",
    }),
  component: JournalArticlePage,
});
